/**
 * Image Constants
 * Centralized configuration for image paths used throughout the application
 */

export const PLACEHOLDER_IMAGE_PATH = '/images/placeholder.png';

/**
 * Get product image URL with fallback to placeholder
 * @param productImg - Product image path from API
 * @returns Full image URL with fallback to placeholder if productImg is null/undefined
 */
export const getProductImageUrl = (productImg: string | null | undefined): string => {
  if (!productImg) {
    return PLACEHOLDER_IMAGE_PATH;
  }
  return `${process.env.REACT_APP_API_URL}${productImg}`;
};
